export default __webpack_public_path__ + "b751c25204ebb85024e8a737234f2bdc.png";